export default __webpack_public_path__ + "static/media/tech-angular.26eca708.svg";